import { useState } from "react";
import { Tab, Nav } from "react-bootstrap";
import styles from "page.module.css";

const TopTabBar = ({ tabs }) => {
  const [activeTab, setActiveTab] = useState(0);
  const handleTabSelect = (index) => {
    setActiveTab(index);
  };
  return (
    <div className="container-fluid my-5">
      <Nav
        variant="tabs"
        className="nav nav-tabs justify-content-center"
        activeKey={activeTab.toString()}
      >
        {tabs.map((tab, index) => (
          <Nav.Item key={index} className="nav-item w-25  text-center">
            <Nav.Link
              eventKey={index.toString()}
              className={`nav-link ${
                activeTab === index ? `active ${styles.bg_custom_3}` : ``
              }`}
              onClick={() => handleTabSelect(index)}
            >
              {tab.label}
            </Nav.Link>
          </Nav.Item>
        ))}
      </Nav>
      <Tab.Content>
        {tabs.map((tab, index) => (
          <Tab.Pane
            key={index}
            eventKey={index.toString()}
            active={activeTab === index}
          >
            <div className="row justify-content-center mt-5">{tab.element}</div>
          </Tab.Pane>
        ))}
      </Tab.Content>
    </div>
  );
};

export default TopTabBar;
